import React from 'react';
import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';
import {GridContainer, Typography, VerticalSpacer} from '../';
import {QuestionIcon} from '../icons/QuestionIcon';
import {ArticleContainer} from './ArticleContainer.styles';

const AnswerWrapper = styled.div`
    .q-and-a-question-interviewee {
        font-weight: 700;
    }
`;

const QuestionWrapper = styled.div`
    position: relative;
    && svg.ue-icon-question {
        width: 1.5em;
        height: 1.5em;
        ${(p) => p.theme.breakpoints.up('md')} {
            position: absolute;
            left: -65px;
            top: -5px;
        }
    }
`;

interface QandAProps {
    question: string;
    answer: string;
}

export interface ArticleQandAProps {
    interviewee?: string;
    qanda?: QandAProps[];
    accentColor?: AccentColorOptions;
}

export const ArticleQandA = ({
    interviewee = '',
    qanda,
    accentColor = 'sky'
}: ArticleQandAProps): JSX.Element => {
    let list: (JSX.Element | undefined)[] = [<div key="empty-list" />];
    if (qanda && qanda.length > 0) {
        list = qanda.map((item, i) => {
            return (
                <div key={`qanda-item-${i}`}>
                    <QuestionWrapper>
                        <QuestionIcon color={accentColor || 'primary'} />
                        <Typography variant="h3" big={true}>
                            {item.question}
                        </Typography>
                        <VerticalSpacer variant="heading" />
                    </QuestionWrapper>
                    <AnswerWrapper>
                        <Typography variant="p" big>
                            {interviewee && (
                                <span className="q-and-a-question-interviewee">
                                    {interviewee}:{' '}
                                </span>
                            )}
                            {item.answer}
                        </Typography>
                    </AnswerWrapper>
                    {i < qanda.length - 1 && (
                        <VerticalSpacer variant="custom" spacing={8} downSmSpacing={6} />
                    )}
                </div>
            );
        });
    }

    return (
        <GridContainer>
            <ArticleContainer>{list}</ArticleContainer>
        </GridContainer>
    );
};
